import { Permission } from './authentication/permission'

export class MenuItem {
    icon: string
    title: string
    path: string
    requiredPermision: Permission
    
    constructor(icon: string, title: string, path: string, requiredPermission: Permission) {
        this.icon = icon
        this.title = title
        this.path = path
        this.requiredPermision = requiredPermission
    }
}